<template>
  <TsSection>
    <TsMedia append-class="max-md:block items-center max-w-max mx-auto">
      <TsMediaStart append-class="max-md:mb-6 max-md:mr-0">
        <TsImage
          v-if="props && props.image"
          data-testid="empty-code-receiver-image"
          :src="props.image"
          alt="empty-code-receiver-primary-image"
          width="278"
          height="154"
        />
      </TsMediaStart>
      <TsMediaContent append-class="max-md:text-center">
        <TsTypography
          as="h1"
          data-testid="empty-code-receiver-heading"
          append-class="mb-0 text-primary leading-[24px]"
          weight="semibold"
          >{{ mainTitle }}</TsTypography
        >
        <TsTypography
          data-testid="empty-code-receiver-text"
          append-class="mb-2.5 mt-1.5 text-idle-black"
          weight="semibold"
        >
          {{ useTranslation('Trolley-checkSavedProductsOrShop', 'Controleer de gedeelde link of') }}
          <template v-if="isAuthenticated">
            <NuxtLinkWithLocale
              to="/"
              class="text-primary underline"
              data-testid="customer-empty-code-receiver-continue-shop-link"
            >
              {{ useTranslation('continueShopping', 'continue shopping') }}</NuxtLinkWithLocale
            >
          </template>
          <template v-else> sign in to check your trolley items </template>
        </TsTypography>
        <template v-if="!isAuthenticated">
          <TsButton
            :link="localePath('/login')"
            data-testid="guest-empty-code-receiver-signin-button"
            append-class="mr-5"
            >{{ useTranslation('signIn', 'Sign In') }}</TsButton
          >
          <TsButton
            :link="localePath('/')"
            outlined
            data-testid="guest-empty-code-receiver-start-shopping-button"
            >{{ useTranslation('startShopping', 'Begin met winkelen') }}</TsButton
          >
        </template>
      </TsMediaContent>
    </TsMedia>
  </TsSection>
</template>

<script lang="ts" setup>
import { useTranslation } from '~/composables/useTranslation';

type Props = {
  mainTitle?: string;
  isAuthenticated?: boolean;
  image?: string;
};

const props = withDefaults(defineProps<Props>(), {
  image: '/images/toolBasket.png',
  mainTitle: 'Nothing to show',
});

const TsMediaStart = defineAsyncComponent(() => import('~/components/organisms/TsMediaStart.vue'));

const TsMediaContent = defineAsyncComponent(
  () => import('~/components/organisms/TsMediaContent.vue')
);

const localePath = useLocalePath();
</script>
